/**
 * Formatea un número a una representación de moneda en pesos colombianos (COP).
 * 
 * @param {number | string | null | undefined} amount El monto a formatear.
 * @returns {string} El monto formateado en pesos colombianos con el símbolo '$' y separadores de miles.
 * 
 * @example
 * formatCurrency(1500000); // '$ 1.500.000'
 */
export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
    }).format(amount || 0);
};